<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Tests">
      <div class="row">
        <div class="col-md-6 form-group">
          Test Type
          <b-form-select
            v-model="testTypeModel"
            :options="testType"
          ></b-form-select>
        </div>
         <div class="col-md-6 form-group">
          Name
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Description
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Duration (mins)
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          No.Of Questions
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Attempts
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Negative Marks
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Each Question Mark
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Start Date
          <b-form-datepicker v-model="startDate"></b-form-datepicker>
        </div>
        <div class="col-md-6 form-group">
          Start Time
          <b-form-timepicker v-model="startTime"></b-form-timepicker>
        </div>
        <div class="col-md-6 form-group">
          End Date
          <b-form-datepicker v-model="endDate"></b-form-datepicker>
        </div>
        <div class="col-md-6 form-group">
          End Time
          <b-form-timepicker v-model="endTime"></b-form-timepicker>
        </div>
        <div class="col-md-6 form-group">
          Result Status
          <b-form-select
            v-model="resultStatusModel"
            :options="resultStatus"
          ></b-form-select>
        </div>
        <div class="col-md-6 form-group">
          Status
          <b-form-select
            v-model="selected1"
            :options="options1"
          ></b-form-select>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          >Save</b-button
        >
      </div>
    </base-block>
  </div>
</template>

<script>
export default {
  data() {
    return {
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
      resultStatusModel: "",
      resultStatus: [
        { text: "No Result" },
        { text: "Result" },
        { text: "Solution" },
      ],
      selected1: null,
      options1: [{ text: "Active" }, { text: "Deactive" }],
      testTypeModel: "",
      testType: [
        { text: "Practice Test" },
        { text: "Mock Test" },
        { text: "Daily Test" },
        { text: "All india Mock Test" },
        { text: "Recruitment Test" },
      ],
    };
  },
};
</script>

